export default __webpack_public_path__ + "static/media/integration.2b81cead.svg";